import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { MonitorType } from 'src/app/core/models/monitor-type.model';
import { User } from 'src/app/core/models/user.model';
import { UserType } from 'src/app/core/models/userType.models';
import { MonitorTypeService } from 'src/app/core/services/monitor-type.service.';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-board',
  templateUrl: './monitorType.component.html',
  styleUrls: ['./monitorType.component.scss']
})

/**
 * Dashboard Component
 */
export class MonitorTypeComponent implements OnInit {
  term: any;
  monitorType: any[];

  addEditMode: any;
  monitorTypeFormGroup: FormGroup;


  constructor(
    private monitorTypeService: MonitorTypeService, 
    private modalService: NgbModal,
  ) { }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Monitor Type', active: true }];
    await this.refresh();
  }

  async refresh() {
    
    this.monitorType = await this.monitorTypeService.getAll();
  

    console.log("refresh called", this)
  }

  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.monitorTypeFormGroup = new FormGroup({
      id: new FormControl<string>(''),
      name: new FormControl<string>(''),


    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, saleRepAddEditFormGroup: this.monitorTypeFormGroup.value});
      if(results=="Save click") {
        const newPrinterType = await this.monitorTypeService.create(this.monitorTypeFormGroup.value);
        if(newPrinterType != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onEdit(modal: unknown, original: MonitorType) {
    this.addEditMode = "Edit";
    this.monitorTypeFormGroup = new FormGroup({
      id: new FormControl<string>(original.id),
      name: new FormControl<string>(original.name),
      

    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, gameFormGroup: this.monitorTypeFormGroup.value});
      if(results=="Save click") {
        const newGame = await this.monitorTypeService.update(original.id, this.monitorTypeFormGroup.value);
        if(newGame != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
    
  } 

  async onDelete( id: string) {
    await this.monitorTypeService.delete(id);
    await this.refresh();     
  } 
}
